import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from './contexts/ThemeContext';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ThemeProvider>
    <CssBaseline />
    <App />
  </ThemeProvider>,
);
